import { lastValueFrom, Observable } from 'rxjs';

import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output
} from '@angular/core';

import {
    FormDirective,
    UploadFileComponent
} from 'bkng';

import { ICampaignParticipant } from '@amt/i-campaign-participant';
import { IUser } from '@amt/i-user';
import { UserService } from '@s/user.service';
import { NgForm } from '@angular/forms';
import { IEnv } from '@alt/i-env';
import { AccountGetResult } from '@api-routes/account/types//account-get-result';
import { IPerson } from '@amt/i-person';
import { Address } from '@alt/address';
import { EnvService } from '@s/env.service';
import { UserWriteResult } from '@api-routes/user/types/user-write-result';
// import { ICountry } from '@amt/i-country';

@Component({
    selector: 'app-campaign-participant-profile-tab-profile',
    templateUrl: './campaign-participant-profile-tab-profile.component.html',
    styleUrls: ['./campaign-participant-profile-tab-profile.component.scss']
})
export class CampaignParticipantProfileTabProfileComponent implements OnInit {
    @Input() campaignParticipant: ICampaignParticipant;
    // country: ICountry;
    env: IEnv;
    @Input() participant: IUser;
    @Input() person: IPerson;
    previewProfilePhotoData: string;
    saved: boolean = false;
    saving: boolean = false;
    @Output() uploadedProfilePhoto = new EventEmitter<unknown>();
    uploadFileOptions: {
        fileToUpload: File;
    };
    uploadProfilePhoto: (options: {
        fileToUpload: File;
    }) => Observable<unknown>;

    constructor (
        public envService: EnvService,
        public userService: UserService,
    ) {
        this.env = envService.data;
    }

    getCountryObject (cc: string): unknown {
        if (!(cc && this.env?.countries)) return;
        return this.env.countries.filter((c) => { return c.code.toUpperCase() === cc.toUpperCase(); })[0];
    }

    ngOnInit (): void {
        if (!this.person?.id) {
            throw new Error(`CampaignParticipantProfileTabProfileComponent: No person id detected in person object!`);
        }
        this.person.data.address = this.person.data.address || <Address>{};
        this.uploadProfilePhoto = (options: {
            fileToUpload: File;
        }): Observable<unknown> => {
            return this.userService.uploadProfilePhoto(this.participant.id, options);
        };
    }

    profilePhotoFileSelected (form: NgForm, uploadFileComponent: UploadFileComponent): void {
        this.uploadFileOptions = uploadFileComponent;
        if (FileReader && uploadFileComponent.fileToUpload) {
            const fr = new FileReader();
            fr.onload = (whateverThisIs) => {
                this.previewProfilePhotoData = <string>(whateverThisIs.target.result);
            };
            fr.readAsDataURL(uploadFileComponent.fileToUpload);
        }
        else if (!uploadFileComponent.fileToUpload) {
            this.previewProfilePhotoData = null;
        }
        form.form.markAsDirty();
    }

    $save (): Promise<UserWriteResult> {
        if (this.saving) {
            return Promise.resolve(<UserWriteResult>undefined);
        }
        this.saved = false;
        this.saving = true;
        const data: AccountGetResult = {
            campaignParticipant: this.campaignParticipant,
            person: this.person,
            user: this.participant,
        };
        return Promise.resolve().then(() => {
            if (this.previewProfilePhotoData) {
                return lastValueFrom(this.uploadProfilePhoto(this.uploadFileOptions)).then((result) => {
                    return result;
                });
            }
            return Promise.resolve();
        }).then(() => {
            return this.userService.save(data.user.id, {
                campaignParticipant: data.campaignParticipant,
                campaignParticipantMission: data.campaignParticipantMission,
                person: data.person,
                user: data.user,
            });
        }).then((res) => {
            console.log("Saved", res);
            this.saved = true;
            return res;
        }).finally(() => {
            setTimeout(() => {
                this.saving = false;
            }, 350);
        });
    }

    async save (form: FormDirective): Promise<UserWriteResult> {
        if (
            !form.ngForm.valid
            ||
            !form.ngForm.dirty
            ||
            this.saving
        ) {
            return await Promise.resolve(<UserWriteResult>undefined);
        }

        try {
            const response = await this.$save();
            form.ngForm.form.markAsPristine();
            return response;
        }
        catch (err) {
            console.error(err);
        }

        return <UserWriteResult>undefined;
    }

    toggleVisible (form: NgForm): void {
        this.campaignParticipant.visible = !this.campaignParticipant.visible;
        form.form.markAsDirty();
    }

    uploadedUserProfilePhoto (event: unknown): void {
        this.uploadedProfilePhoto.emit(event);
    }
}
